export enum StorageKeyEnum {
    LicenceId = 'licenceId',
    DeviceId = 'deviceId',
    DeviceToken = 'deviceToken',
    CurrentProfileUuid = 'currentProfileUuid',
    PosCartKey = 'posCartKey',
    PhoneCartKey = 'phoneCartKey',
    PosAutomaticContainerRemovals = 'posAutomaticContainerRemovals',
    PhoneAutomaticContainerRemovals = 'phoneAutomaticContainerRemovals',
    Printers = 'printers',
    RefreshToken = 'refreshToken',
    NotificationSoundPreferences = 'notificationSoundPreferences',
}

export const authStorageKeys = [
    StorageKeyEnum.LicenceId,
    StorageKeyEnum.DeviceId,
    StorageKeyEnum.DeviceToken,
    StorageKeyEnum.CurrentProfileUuid,
    StorageKeyEnum.RefreshToken,
]
